import instance from 'utils/axios/instance.axios';
import { EMPLOYEES } from './_constant';

export const getAll = (pagination, filters) =>
  instance.get(EMPLOYEES.GET_ALL, { params: { ...pagination, ...filters } });

export const getGeneralInfoById = (id) => instance.get(EMPLOYEES.GET_BY_ID(id));

export const getAllRoles = () => instance.get(EMPLOYEES.GET_ALL_ROLES);

export const getById = (id) => instance.get(EMPLOYEES.GET_BY_ID(id));

export const create = (body = {}) => instance.post(EMPLOYEES.CREATE, body);

export const update = ({ id, body }) => instance.patch(EMPLOYEES.UPDATE(id), body);
export const updateGenderById = ({ id, body }) => instance.patch(EMPLOYEES.UPDATE_GENDER(id), body);

export const deleteById = (id) => instance.delete(EMPLOYEES.DELETE_BY_ID(id));

export const resetPassword = (body = {}) => instance.post(EMPLOYEES.RESET_PASSWORD, body);

export const downloadScientificProfileFile = ({ userId }) =>
  instance.post(EMPLOYEES.DOWNLOAD_SCIENTIFIC_PROFILE_FILE, { userId }, { responseType: 'blob' });

export const exportExcel = () =>
  instance.post(EMPLOYEES.EXPORT_EXCEL, {}, { responseType: 'blob' });
